import { EditIcon, TextButton } from '@maersktankersdigital/web-components'
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useEffect, useState } from 'react'
import { IQuestionnaireField } from '~api/vessels/read'
import { Field } from './open-section-modal'

interface RadioChoiceProps extends IQuestionnaireField {
  onChangeHandler: (field: Field) => void
  inputData?: Field[]
  isDisabled?: boolean
}

export function RadioChoice({
  onChangeHandler,
  id,
  possibleAnswers,
  value,
  inputData,
  readOnly,
  isDisabled,
}: RadioChoiceProps) {
  const [isEditing, setIsEditing] = useState<boolean>()
  const canEdit = !isDisabled && !readOnly

  useEffect(() => {
    setIsEditing(!value)
  }, [value])

  if (!possibleAnswers) return null

  return (
    <>
      <RadioGroup
        onChange={(e, value) => onChangeHandler({ id, value })}
        value={value}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'initial',
          mt: -2,
        }}
      >
        {possibleAnswers.map((answer) => {
          const inputValue = inputData?.find((i) => i.id === id)?.value

          const isChecked =
            isEditing && inputValue ? answer === inputValue : answer === value

          return (
            <FormControlLabel
              key={answer}
              control={
                <Radio
                  checked={isChecked}
                  value={answer}
                  disabled={!canEdit || !isEditing}
                />
              }
              label={answer}
            />
          )
        })}
      </RadioGroup>
      {canEdit && value && (
        <Box
          component={TextButton}
          onClick={() => setIsEditing(!isEditing)}
          icon={<EditIcon width="16px" height="16px" />}
          sx={{ pl: 0 }}
        >
          {isEditing ? 'Cancel' : 'Edit'}
        </Box>
      )}
    </>
  )
}
